// import axios from 'axios'
import axios from '../../helpers/Axios'

export const countrymodule = {

	namespaced: true,

	state: {

		allCountries: []
	},
	getters: {

		allCountries: state => { return state.allCountries; }
	},
	actions: {

		getCountries({ commit }) {
			return axios.get('/Country').then(response => {

				commit('allCountries', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		allCountries(state, countries) {
			state.allCountries = countries
		}
	}

}
